import { request } from "$/lib/api"
import {
  ChatThread,
  ChatThreadKind,
  MessageVariable,
  Route,
  StoreCustomerMessageVariable,
  StoreMessageVariable,
  chatThreadKey,
  populateRoute,
} from "@repo/common"
import { queryOptions } from "@tanstack/react-query"

async function fetchResolvedVariables(
  jobId: string,
): Promise<Record<MessageVariable, string>> {
  return await request<Record<MessageVariable, string>>({
    url: populateRoute(Route.MESSAGE_VARIABLE__RESOLVE, jobId),
    method: "GET",
  })
}

export const MESSAGE_VARIABLE_QUERY_KEY = "message-variable"

export const resolvedVariablesQueryOptions = (jobId: string) =>
  queryOptions({
    queryKey: [MESSAGE_VARIABLE_QUERY_KEY, "resolved", jobId],
    queryFn: () => fetchResolvedVariables(jobId),
  })

async function fetchResolvedStoreVariables(
  storeId: string,
): Promise<Record<StoreMessageVariable, string>> {
  return await request<Record<StoreMessageVariable, string>>({
    url: populateRoute(Route.MESSAGE_VARIABLE__RESOLVE_FOR_STORE, storeId),
    method: "GET",
  })
}

/** Only the variables that are the same for every job in the store. */
export const resolvedStoreVariablesQueryOptions = (storeId: string) =>
  queryOptions({
    queryKey: [MESSAGE_VARIABLE_QUERY_KEY, "resolved", "store", storeId],
    queryFn: () => fetchResolvedStoreVariables(storeId),
  })

async function fetchResolvedThreadVariables(
  thread: ChatThread,
): Promise<Partial<Record<MessageVariable, string>>> {
  if (thread.kind === ChatThreadKind.JOB) {
    return fetchResolvedVariables(thread.jobId)
  }
  return await request<Record<StoreCustomerMessageVariable, string>>({
    url: populateRoute(
      Route.MESSAGE_VARIABLE__RESOLVE_FOR_STORE_CUSTOMER,
      thread.storeCustomerId,
    ),
    method: "GET",
  })
}

/**
 * The variables a chat's composer can fill in. A store customer's own chat
 * has no job, so only the store's and the customer's variables resolve.
 */
export const resolvedThreadVariablesQueryOptions = (thread: ChatThread) =>
  queryOptions({
    queryKey: [MESSAGE_VARIABLE_QUERY_KEY, "resolved", chatThreadKey(thread)],
    queryFn: () => fetchResolvedThreadVariables(thread),
  })
